import React from "react";
import PlaylistBottomSheet from "../../../../Components/PlaylistBottomSheet/PlaylistBottomSheet";
import { OverlayTriggerState } from "react-stately";
import { playlistMessages } from "../../../EditPlaylist/playlistMessages";
import { ROUTES } from "../../../const";
import { usePlaylistQuery } from "../../../../api/useQueries";
import { Button } from "@evidenceb/athena-common/design-system/Button";
import { useIntl } from "react-intl";
import DuplicateButton from "../DuplicateButton/DuplicateButton";
import { useUrl } from "../../../../../../../hooks/usePage";
import { Pagetype } from "../../../../../../../interfaces/Config";
import { PlaylistStatus } from "../../../../type";
import ArchiveButton from "../ArchiveButton/ArchiveButton";
import PlaylistDetail from "../PlaylistDetail/PlaylistDetail";

type Props = {
    state: OverlayTriggerState;
    playlistId: string | undefined;
    nbPlaylists?: number;
    onClearPreview: () => void;
};

const BottomSheetPreview = ({
    state,
    playlistId,
    nbPlaylists,
    onClearPreview,
}: Props) => {
    const intl = useIntl();
    const baseurl = useUrl(Pagetype.WORKMODE_PLAYLIST);

    const { data: playlist } = usePlaylistQuery(playlistId ?? "", {
        enabled: !!playlistId,
    });
    if (!playlist) {
        return null;
    }

    return (
        <PlaylistBottomSheet state={state} dialogTitle={playlist.name}>
            <div className="playlist-preview-details">
                <div className="playlist-preview-details__action-tray">
                    <Button
                        label={intl.formatMessage(
                            playlistMessages.editRecipients
                        )}
                        asRouterLink={{
                            to: `${baseurl}/${ROUTES.editAssignment}/${playlistId}`,
                        }}
                    />
                    <DuplicateButton
                        playlistInPreview={playlist}
                        nbPlaylists={nbPlaylists}
                    />
                    {playlist.status.status !== PlaylistStatus.ARCHIVED && (
                        <ArchiveButton
                            playlistId={playlistId}
                            onArchive={onClearPreview}
                        />
                    )}
                </div>
                <PlaylistDetail playlist={playlist} />
            </div>
        </PlaylistBottomSheet>
    );
};
export default BottomSheetPreview;
